import React, {useEffect, useState} from 'react'
import {Card, CardBody, CardHeader} from "reactstrap";
import {
    AddImageButton,
    CheckboxContainer,
    Checkmark,
    CurrencySymbol,
    CustomHeader,
    CustomInput,
    CustomInputWrapper,
    CustomTD,
    FleetButton,
    IconContainer,
    StyledTable,
    StyledTableHeaderCell
} from "@pages/new-design-components/custom-components";
import IcoMoon from "react-icomoon";
import IconSet from "@assets/selection.json";
import CustomDropdownComponent from "@pages/components/JobDetailsComponents/CustomInspectionDropDown";
import {CURRENCY, parseToWord, FLEET_MS_API_URL} from "@constants/index";
import CustomCheckbox from "@pages/components/JobDetailsComponents/CustomCheckbox";
import axios from "../../../../config/axios";
import notify from "@utils/notify";
import {LoaderContainer, override} from "@pages/reusable-components/styled-components";
import {ClipLoader} from "react-spinners";


export default function QuoteComponent({   initialData,
                                           departments,
                                           initialPartsData = [],
                                           damages,
                                           viewImage,
                                           fleetId,
                                           quote,
                                           setShowInspectionRecord,
                                           vehicleId,
                                       }) {

    const [data,setData] = useState([]);
    const [partsData,setPartsData] = useState([]);
    const [deleteIds,setDeleteIds] = useState([]);
    const [deletePartIds,setDeletePartIds] = useState([]);
    const [errors,setErrors] = useState({});
    const [loading,setLoading] = useState(true);

    useEffect(() => {
        if (initialData.length > 0) {
            setData(initialData);
            if (loading) {
                setLoading(false);
            }
        }
    }, [initialData]);
    useEffect(() => {
        if (initialPartsData.length > 0) {
            setPartsData(initialPartsData);
            if (loading) {
                setLoading(false);
            }
        }
    },[initialPartsData])

    const saveData = async () => {
        let invalidData = {}

        data.forEach((item,index)=> {
            if (!item.title || !item.department) {
                if (!invalidData.hasOwnProperty('data')) {
                    invalidData['data'] = {}
                }
                if (!invalidData['data'].hasOwnProperty(index)) {
                    invalidData['data'][index] = []
                }
                invalidData['data'][index].push('title')
                invalidData['data'][index].push('department')
            }
        })
        partsData.forEach((item,index)=> {
            if (!item.part || !item.department) {
                if (!invalidData.hasOwnProperty('partsData')) {
                    invalidData['partsData'] = {}
                }
                if (!invalidData['partsData'].hasOwnProperty(index)) {
                    invalidData['partsData'][index] = []
                }
                invalidData['partsData'][index].push('title')
                invalidData['partsData'][index].push('department')
            }
        })

        if (Object.keys(invalidData).length === 0) {
            setErrors({})
            setLoading(true)
            const createdPartsData = partsData.filter(item => item.id === undefined);
            const updatedPartsData = partsData.filter(item => item.edited === true);

            try {
                const response = await axios.post(`${FLEET_MS_API_URL}/fleet-management/create-quote`,{
                    parts: [...createdPartsData,...updatedPartsData],
                    deletedWorks: [...deleteIds],
                    deletedParts: [...deletePartIds],
                    quote,
                    fleetId,
                    vehicleId,
                })
                if (response.status === 200) {
                    const q = response.data.data
                    const created = data.filter(item => item.id === undefined);
                    const updated = data.filter(item => item.edited === true);
                    await Promise.all([createQuoteTask(created, q.id), updateQuoteTask(updated, q.id)]);
                    setLoading(false)
                }
            } catch (error) {
                setLoading(false)
                notify.warning('Something went wrong please try again later!');
                console.error('Error:', error);
            }
        }
        else {
            setLoading(false)
            setErrors(invalidData)
        }

    }
    const createQuoteTask = async (tasks,quoteId) => {
        if (tasks.length) {

            try {
                const createPromises = tasks.map(async (task) => {
                    const formData = new FormData();
                    formData.append('quote_id',quoteId)
                    formData.append('fleetId',fleetId)
                    Object.keys(task).forEach((key) => {
                        if (key === "newDocuments") {
                            task[key].forEach((file) => {
                                formData.append('documents[]', file.file);
                            });
                        } else if (key === "department") {
                            formData.append("department_id", task[key].id);
                            formData.append("department_name", task[key].name);
                        } else if (key !== 'documents') {
                            formData.append(key, task[key]);
                        }
                    });

                    return axios.post(
                        `${FLEET_MS_API_URL}/fleet-management/create-quote-task`,
                        formData,
                        { headers: { "Content-Type": "multipart/form-data" } }
                    );
                });

                await Promise.all(createPromises);

            } catch (error) {
                console.error("Error:", error);
            }
        }
    };
    const updateQuoteTask = async (tasks,quoteId) => {
        if (tasks.length) {
            try {
                const updatePromises = tasks.map(async (task) => {
                    const formData = new FormData();
                    formData.append('quote_id',quoteId)
                    formData.append('fleetId',fleetId)
                    Object.keys(task).forEach((key) => {
                        if (key === "newDocuments") {
                            task[key].forEach((file) => {
                                formData.append('documents[]', file.file);
                            });
                        }  else if (key === "department") {
                            formData.append("department_id", task[key].id);
                            formData.append("department_name", task[key].name);
                        } else if (key !== 'documents') {
                            formData.append(key, task[key]);
                        }
                    });

                    return axios.post(
                        `${FLEET_MS_API_URL}/fleet-management/update-quote-task/${task.id}`,
                        formData,
                        { headers: { "Content-Type": "multipart/form-data" } }
                    );
                });

                await Promise.all(updatePromises);

            } catch (error) {
                console.error("Error:", error);
            }
        }

    };
    const isFieldInvalid = (parent,index, fieldName) => {
        return errors.hasOwnProperty(parent) &&  errors[parent].hasOwnProperty(index) && errors[parent][index].includes(fieldName);
    };
    const handleButtonClick = (id) => {
        document.getElementById(id).click();
    }


    const addNewRow = () => {
        let tempData = [...data]
        let row =  {
            title: null,
            hour: null,
            cost: null,
            department: null,
            added_to_report: 0,
        }
        tempData.push(row)
        setData(tempData)
    }
    const changeData = ({index,key,value = null}) => {
        let tempData = [...data]
        if (key === 'added_to_report') {
            tempData[index]['added_to_report'] = tempData[index]['added_to_report'] === 0 || tempData[index]['added_to_report'] === null ? 1 : 0;
        } else {
            tempData[index][key] = value
        }
        if (tempData[index]?.id) {
            tempData[index]['edited'] = true
        }
        setData(tempData)
    }
    const deleteRow = ({index,id}) => {
        let tempData = [...data];
        let tempIds = [...deleteIds]
        if (id && !tempIds.includes(id)) {
            tempIds.push(id)
            setDeleteIds(tempIds)
        }
        tempData.splice(index, 1);
        setData(tempData)
    }

    const handleFileSelect = async (file, index) => {
        if (file) {
            let tempData = [...data];
            if (!tempData[index].newDocuments) {
                tempData[index].newDocuments = [];
            }
            let reader = new FileReader();
            reader.readAsDataURL(file)
            const preview =  URL.createObjectURL(file)
            if (tempData[index]?.id) {
                tempData[index]['edited'] = true
            }
            tempData[index].newDocuments.push({
                preview,
                file,
            });

            setData(tempData);
        }
    }

    const handleFileChange = (event,index) => {
        const file = event.target.files[0];
        if (file) {
            handleFileSelect(file,index);
        }
    };

    const changePartsData = ({index,key,value = null}) => {
        let tempData = [...partsData];
        if (key === 'added_to_report') {
            tempData[index]['added_to_report'] = tempData[index]['added_to_report'] === 0 || tempData[index]['added_to_report'] === null ? 1 : 0;
        } else {
            tempData[index][key] = value;
        }

        if (tempData[index]?.id) {
            tempData[index]['edited'] = true;
        }

        setPartsData(tempData);
    };

    const addNewPartsRow = () => {
        let tempData = [...partsData]
        let row =  {
            part_number: null,
            part: null,
            cost: null,
            department: null,
            added_to_report: 0,
            status: 'to_do',
        }
        tempData.push(row)
        setPartsData(tempData)
    }
    const deletePartsRow = ({index,id}) => {
        let tempData = [...partsData];
        let tempIds = [...deletePartIds]
        if (id && !tempIds.includes(id)) {
            tempIds.push(id)
            setDeletePartIds(tempIds)
        }
        tempData.splice(index, 1);
        setPartsData(tempData)
    }
    return (
        loading ?  <LoaderContainer>
                <ClipLoader
                    css={override}
                    size={40}
                    color={`#7B61E4`}
                    loading={loading}
                />
            </LoaderContainer>
            :
        <>
            <Card>

                <CardHeader className={'border-bottom-0 d-flex flex-wrap justify-content-between'}>
                    <CustomHeader fontSize={'16px'}>
                        Work Carried Out
                    </CustomHeader>
                    <div className={'d-flex flex-wrap g-10'}>
                        <FleetButton
                            height={'40px'}
                            width={'224px'}
                            padding={'0 7px 0 0'}
                            backgroundColor={'#F3994A'}
                            radius={'8px'}
                            onClick={()=>{
                                setShowInspectionRecord()
                            }}
                        >
                            <IcoMoon
                                className={'cursor-pointer'}
                                iconSet={IconSet}
                                icon={'icont-wrench'}
                                width={'50px'}
                                height={'20px'}
                            />
                            View Service Record
                        </FleetButton>
                        <FleetButton
                            height={'40px'}
                            width={'164px'}
                            backgroundColor={'#219852'}
                            radius={'8px'}
                            onClick={saveData}
                        >
                            Save
                        </FleetButton>
                    </div>

                </CardHeader>
                <CardBody className={'overflow-auto'}>
                    <StyledTable className={'table-borderless'}>
                        <thead className={'header-white-text'}>
                        <tr>
                            <StyledTableHeaderCell className={'text-center'} width={'15%'} color={'#0000008C'}>
                                Work Done
                            </StyledTableHeaderCell>

                            <StyledTableHeaderCell className={'text-center'} width={'15%'} color={'#0000008C'}>
                                Department
                            </StyledTableHeaderCell>

                            <StyledTableHeaderCell className={'text-center'} width={'10%'} color={'#0000008C'}>
                                Labour(h)
                            </StyledTableHeaderCell>
                            <StyledTableHeaderCell className={'text-center'} width={'10%'} color={'#0000008C'}>
                                Cost
                            </StyledTableHeaderCell>
                            <StyledTableHeaderCell className={'text-center'} width={'10%'} color={'#0000008C'}>
                                Add to Report
                            </StyledTableHeaderCell>
                            <StyledTableHeaderCell className={'text-center'} width={'20%'} color={'#0000008C'}>
                                Status
                            </StyledTableHeaderCell>
                            <StyledTableHeaderCell className={'text-center'} width={'10%'} color={'#0000008C'}>
                                Image
                            </StyledTableHeaderCell>
                            <StyledTableHeaderCell className={'text-center'} width={'10%'} color={'#0000008C'}>

                            </StyledTableHeaderCell>

                        </tr>
                        </thead>
                        <tbody>
                        {data.length ?
                            data.map((item, index)=>{
                                const images = damages.find(damage=>damage.task_id === item.id)?.images
                                const image = images?.length ? images[0] : null
                                return <tr key={`4_${index}`}>
                                    <CustomTD width={'15%'}>
                                        <CustomInput radius={'8px'}
                                                     onChange={(e)=>{
                                                         changeData({
                                                             index,
                                                             key: 'title',
                                                             value: e.target.value
                                                         })
                                                     }
                                                     }
                                                     borderBottom={isFieldInvalid('data',index, "title") ? '1px solid red' : '1px solid #C0D9FF59'}
                                                     border={isFieldInvalid('data',index, "title") ? '1px solid red' : '1px solid #C0D9FF59'}
                                                     value={parseToWord(item.title)} />
                                    </CustomTD>
                                    <CustomTD width={'15%'}>
                                        <CustomDropdownComponent
                                            withoutDot
                                            border={isFieldInvalid('data',index, "department") ? '1px solid red' : '1px solid #C0D9FF59'}
                                            selectedTitle={item.department?.name === 'workshop' ? 'ply lining' : item.department?.name}
                                            statusArrayKey={'departments'}
                                            handleChange={(value)=>{
                                                const department = departments.find(item=>item.name === value)
                                                changeData({
                                                    index,
                                                    key: 'department',
                                                    value: department
                                                })
                                            }}
                                        />
                                    </CustomTD>
                                    <CustomTD width={'10%'}>
                                        <CustomInput radius={'8px'}
                                                     onChange={(e)=>{
                                                         changeData({
                                                             index,
                                                             key: 'hour',
                                                             value: e.target.value
                                                         })
                                                     }
                                                     }
                                                     borderBottom={'1px solid #C0D9FF59'}
                                                     border={'1px solid #C0D9FF59'}
                                                     value={item.hour} />
                                    </CustomTD>
                                    <CustomTD width={'10%'}>
                                        <CustomInputWrapper>
                                            <CurrencySymbol>{CURRENCY}</CurrencySymbol>
                                            <CustomInput
                                                radius={'8px'}
                                                padding={'10px 10px 10px 30px'}
                                                onChange={(e) => {
                                                    changeData({
                                                        index,
                                                        key: 'cost',
                                                        value: e.target.value,
                                                    });
                                                }}
                                                border={'1px solid #C0D9FF59'}
                                                borderBottom={'1px solid #C0D9FF59'}
                                                value={item.cost}
                                                placeholder="Enter cost"
                                            />
                                        </CustomInputWrapper>
                                    </CustomTD>

                                    <CustomTD width={'10%'} className={'text-center'}>
                                        <CheckboxContainer checked={item?.added_to_report} onClick={()=>{
                                            changeData({
                                                index,
                                                key: 'added_to_report'
                                            })
                                        }}>
                                            <Checkmark height={'21px'} width={'23px'}  checked={item?.added_to_report} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                <path d="M20.285 6.285a1 1 0 00-1.415 0L10 15.585 5.715 11.3a1 1 0 00-1.415 1.415l5 5a1 1 0 001.415 0l10-10a1 1 0 000-1.415z" />
                                            </Checkmark>
                                        </CheckboxContainer>
                                    </CustomTD>
                                    <CustomTD width={'20%'}>
                                    <CustomDropdownComponent
                                        withoutDot
                                        border={'1px solid #C0D9FF59'}
                                        selectedTitle={item.status}
                                        statusArrayKey={'quotePassStatuses'}
                                        handleChange={(value)=>{
                                            changeData({
                                                index,
                                                key: 'status',
                                                value: value
                                            })
                                        }}
                                    />
                                    </CustomTD>
                                        <CustomTD color={'#3F8CFF'}
                                                  className={'text-center cursor-pointer'}
                                                  width={'10%'}>
                                            {image ? <span onClick={() => {
                                                viewImage(image?.image_link)
                                            }}>View</span> : item?.documents?.length ?
                                                <span onClick={() => {
                                                    viewImage(item?.documents[0]?.image_link)
                                                }}>View</span>
                                            : item?.newDocuments?.length ?
                                                    <img src={item?.newDocuments[0].preview} width={'25px'} alt=""/>
                                                    : item.department?.name === 'body shop' &&  <AddImageButton place={'center'} onClick={()=>handleButtonClick(`input_${index}`)}>
                                                    +
                                                    <input
                                                        type="file"
                                                        id={`input_${index}`}
                                                        style={{ display: 'none' }}
                                                        onChange={(e)=>{
                                                            handleFileChange(e,index)
                                                        }}
                                                    />
                                                </AddImageButton>
                                            }
                                        </CustomTD>
                                    <CustomTD width={'10%'}>
                                        <IconContainer>
                                            <IcoMoon
                                                className={'cursor-pointer'}
                                                iconSet={IconSet}
                                                icon={'delete_new_outline'}
                                                size={20}
                                                onClick={() => {
                                                    deleteRow({index, id: item?.id || null})
                                                }}
                                            />
                                        </IconContainer>

                                    </CustomTD>
                                </tr>
                            })
                            : null
                        }
                        <tr>
                            <td colSpan="8" className={'text-center'}>
                                <FleetButton
                                    height={'43px'}
                                    width={'114px'}
                                    backgroundColor={'#FDF0E4'}
                                    color={'#F3994A'}
                                    fontSize={'14px'}
                                    radius={'32px'}
                                    onClick={addNewRow}
                                >
                                    &#43; Add new
                                </FleetButton>
                            </td>
                        </tr>

                        </tbody>
                    </StyledTable>
                </CardBody>
            </Card>

            <Card>
                <CardHeader className={'border-bottom-0'}>
                    <CustomHeader fontSize={'16px'}>
                        Parts
                    </CustomHeader>
                </CardHeader>
                <CardBody className={'overflow-auto'}>
                    <StyledTable className={'table-borderless'}>
                        <thead className={'header-white-text'}>
                        <tr>
                            <StyledTableHeaderCell fontSize={'14px'} className={'text-center'} width={'15%'} color={'#0000008C'}>
                                Part
                            </StyledTableHeaderCell>
                            <StyledTableHeaderCell className={'text-center'} width={'15%'} color={'#0000008C'}>
                                Department
                            </StyledTableHeaderCell>
                            <StyledTableHeaderCell fontSize={'14px'} className={'text-center'} width={'15%'} color={'#0000008C'}>
                                No.
                            </StyledTableHeaderCell>
                            <StyledTableHeaderCell fontSize={'14px'} className={'text-center'} width={'15%'} color={'#0000008C'}>
                                Cost
                            </StyledTableHeaderCell>
                            <StyledTableHeaderCell className={'text-center'} width={'10%'} color={'#0000008C'}>
                                Add to Report
                            </StyledTableHeaderCell>
                            <StyledTableHeaderCell fontSize={'14px'} className={'text-center'} width={'10%'} color={'#0000008C'}>
                                Ordered
                            </StyledTableHeaderCell>
                            <StyledTableHeaderCell className={'text-center'} width={'10%'} color={'#0000008C'}>
                            </StyledTableHeaderCell>

                        </tr>
                        </thead>
                        <tbody>
                        {
                            partsData.length ?
                                partsData.map((item,index)=>{
                                    return  <tr key={`3_${index}`}>
                                        <CustomTD className={'text-center'} width={'15%'}>
                                            <CustomInput radius={'8px'}
                                                         onChange={(e)=>{
                                                             changePartsData({
                                                                 index,
                                                                 key: 'part',
                                                                 value: e.target.value
                                                             })
                                                         }
                                                         }
                                                         border={isFieldInvalid('partsData',index, "part") ? '1px solid red' : '1px solid #C0D9FF59'}
                                                         value={item.part} />
                                        </CustomTD>
                                        <CustomTD width={'15%'}>
                                            <CustomDropdownComponent
                                                withoutDot
                                                border={isFieldInvalid('partsData',index, "department") ? '1px solid red' : '1px solid #C0D9FF59'}
                                                selectedTitle={item.department?.name}
                                                statusArrayKey={'departments'}
                                                handleChange={(value)=>{
                                                    const department = departments.find(item=>item.name === value)
                                                    changePartsData({
                                                        index,
                                                        key: 'department',
                                                        value: department
                                                    })
                                                }}
                                            />
                                        </CustomTD>
                                        <CustomTD className={'text-center'} width={'15%'}>
                                            <CustomInput radius={'8px'}
                                                         onChange={(e)=>{
                                                             changePartsData({
                                                                 index,
                                                                 key: 'part_number',
                                                                 value: e.target.value
                                                             })
                                                         }
                                                         }
                                                         border={'1px solid #C0D9FF59'}
                                                         value={item.part_number} />
                                        </CustomTD>
                                        <CustomTD className={'text-center'} width={'15%'}>
                                            <CustomInputWrapper>
                                                <CurrencySymbol>{CURRENCY}</CurrencySymbol>
                                                <CustomInput
                                                    radius={'8px'}
                                                    padding={'10px 10px 10px 30px'}
                                                    onChange={(e) => {
                                                        changePartsData({
                                                            index,
                                                            key: 'cost',
                                                            value: e.target.value,
                                                        });
                                                    }}
                                                    border={'1px solid #C0D9FF59'}
                                                    value={item.cost}
                                                    placeholder="Enter cost"
                                                />
                                            </CustomInputWrapper>
                                        </CustomTD>
                                        <CustomTD className={'text-center'} width={'10%'}>
                                            <CheckboxContainer checked={item?.added_to_report} onClick={()=>{
                                                changePartsData({
                                                    index,
                                                    key: 'added_to_report'
                                                })
                                            }}>
                                                <Checkmark height={'21px'} width={'23px'} checked={item?.added_to_report} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                    <path d="M20.285 6.285a1 1 0 00-1.415 0L10 15.585 5.715 11.3a1 1 0 00-1.415 1.415l5 5a1 1 0 001.415 0l10-10a1 1 0 000-1.415z" />
                                                </Checkmark>
                                            </CheckboxContainer>
                                        </CustomTD>
                                        <CustomTD className={'text-center'} width={'10%'}>
                                            <CustomCheckbox checked={item.status === 'completed'} onClick={()=>{
                                                changePartsData({
                                                    index,
                                                    key: 'status',
                                                    value: item.status === 'completed' ? 'to_do' : 'completed',
                                                });
                                            }
                                            }/>
                                        </CustomTD>
                                        <CustomTD width={'10%'}>
                                            <IconContainer>
                                                <IcoMoon
                                                    className={'cursor-pointer'}
                                                    iconSet={IconSet}
                                                    icon={'delete_new_outline'}
                                                    size={20}
                                                    onClick={() => {
                                                        deletePartsRow({index, id: item?.id || null})
                                                    }}
                                                />
                                            </IconContainer>

                                        </CustomTD>

                                    </tr>
                                })
                                : null
                        }
                        <tr>
                            <td colSpan="7" className={'text-center'}>
                                <FleetButton
                                    height={'43px'}
                                    width={'114px'}
                                    backgroundColor={'#FDF0E4'}
                                    color={'#F3994A'}
                                    fontSize={'14px'}
                                    radius={'32px'}
                                    onClick={addNewPartsRow}
                                >
                                    &#43;  Add new
                                </FleetButton>
                            </td>
                        </tr>
                        </tbody>
                    </StyledTable>
                </CardBody>
            </Card>
        </>
    )
}